const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) target.classList.add("graphic--visible");
    });
  },
  {
    threshold: [0.1],
    rootMargin: "0% 0% 0% 0%",
  }
);

const graphicEls = document.querySelectorAll(".graphic");
graphicEls?.forEach((el) => {
  observer.observe(el);
});
